export default "__VITE_ASSET__BAzJW3rA__"